import { t } from 'i18next';
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import discount from '../../assets/images/new/discount.png';

const ExitIntentModal = ({ show, onHide, slug, onSelectCity }) => {
  return (
   <Modal
  show={show}
  onHide={onHide}
  centered
  backdrop="static"
  keyboard={false}
  className="exit-modal-unique "
>
  <Modal.Header closeButton className="border-0" style={{padding:"0.5em"}} />

 <Modal.Body className="text-center px-4 pb-4 exitIntent-body">
  {/* Floating Icon */}
  <div className="offer-icon mb-2">
    <img src={discount} alt="Offer Icon" />
  </div>

  {/* Title */}
  <h5 className="fw-bold text-dark mb-2">
     {t("Want to Save More on Your Puja?")}
  </h5>

  {/* Subtitle */}
  <p className="text-muted mb-1 " style={{ fontSize: "16px" }}>
   {t("Flat 30% Off")}
  </p>

  {/* Divider */}
  <div className="divider mb-2" />

  {/* Offer Text */}
<p
  className="mt-2"
  style={{
    color: "#333",
    fontSize: "15px",
    lineHeight: "1.7",
    fontFamily: "Bricolage Grotesque",
  }}
>
  {t("Book")} <strong>{t("Satyanarayana Puja")}</strong> {t("on the")}{" "}
  <strong>{t("Myomnamo App")}</strong> {t("and enjoy an")}
  {/* <br /> */}
  <strong className="text-color">{t(" additional Rs 166 OFF")}</strong> {t("on top of the existing offer.")}
</p>

{/* Coupon Box */}
<div className="coupon-box mt-2"> 
  <span className="coupon-label small">{t("Use Code")}</span>

  <div className="coupon-code">
    <span id="couponCode">MYOMNAMO10</span>

    {/* <button
      className="copy-btn"
      onClick={() => {
        navigator.clipboard.writeText("ABC10");
        alert("Coupon code copied!");
      }}
    >
      <i className="fa-regular fa-copy"></i>
    </button> */}
  </div>
</div>

{/* Price */}
<p className=" mt-3">
  {t("Pay just")} <span className='fw-semibold' >₹3,333</span>{" "}
  <span className="text-muted text-decoration-line-through">
    ₹3,499
  </span>
</p>


  {/* CTA Button */}
  <div className="mt-4">
    <Button
      href="https://play.google.com/store/apps/details?id=spiritualapp.myomnamo&pli=1"
      target="_blank"
      className="playstore-btn"
    >
      <i className="fa-brands fa-google-play me-2"></i>
      {t("Download App & Save More")}
    </Button>
  </div>

  {/* Sub Text */}
  <small className="d-block mt-3 text-muted">
    🙏 {t("App-only offer · Limited time")}
  </small>
</Modal.Body>

</Modal>


  );
};

export default ExitIntentModal;
